module.exports = __webpack_public_path__ + "static/media/news2.f3e68cc0.png";